import { render, staticRenderFns } from "./addRoleShop.vue?vue&type=template&id=0ec428ab&scoped=true"
import script from "./addRoleShop.vue?vue&type=script&lang=js"
export * from "./addRoleShop.vue?vue&type=script&lang=js"
import style0 from "./addRoleShop.vue?vue&type=style&index=0&id=0ec428ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec428ab",
  null
  
)

export default component.exports